<app>

    <nav-bar
            user="{opts.user}"
            show-filter-bar="{false}"

    ></nav-bar>


    <!--  hero banner   -->
    <section class="demo-hero-5" data-pages="parallax"
             data-pages-bg-image="/static/eshop/assets/images/engineering.jpg">
        <div class="container-xs-height full-height hero-gradient">
            <div class="col-xs-height col-middle text-center">
                <h1 class="text-white inner bold">Aeroviewer for Architectural & Civil Engineering Projects</h1>
            </div>
        </div>
    </section>
    <!--  End of hero banner   -->

    <section class="bg-master-lightest p-b-60 p-t-60">
        <div class="container">
            <div class="md-p-l-20 md-p-r-20 xs-no-padding">
                <h5 class="block-title hint-text no-margin">So far specific ports</h5>
                <div class="row">
                    <div class="col">
                        <p class="h1 m-t-5">been damaged by earthquakes (Greek project), pedestrian coastal areas to be
                            redesigned (Barcelona-Spain project)</p>
                    </div>
                    <div class="col no-padding xs-p-l-15 xs-p-r-15">
                        <div class="p-l-35 md-p-l-5">
                            <p>a villa on a beach front land to be build (a Sweden architect office), a world-wide known
                                archaeological site and museum proposal (by a famous architect office) and many more
                                have
                                been using AEROVIEWER as their preferred source of aerial visual content</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="p-b-50 p-t-50 bg-master-darkest sm-no-margin"
             data-pages-bg-image="/static/web/assets/images/engineering-showcase.png"
             data-bg-overlay="black" data-overlay-opacity="0.3" data-pages="parallax">
        <div class="container p-b-50 p-t-50">
            <div class="row">
                <div class="col text-center">
                    <p class="h1 text-white block-title m-b-0">Real example of the use of visual content</p>
                    <p class="h5 text-white light p-b-10">licensed by the AEROVIEWER platform to an Engineering and
                        Consulting company.</p>
                    <a href="http://www.cnway.gr/project_category/harbor-engineering/marinas-and-small-harbors/"
                       class="btn  btn-complete btn-rounded btn-lg" target="_blank">Visit</a>
                </div>
            </div>
        </div>
        <div class="bg-overlay" style="background-color: black; opacity: 0.3;"></div>
    </section>

    <avr-footer></avr-footer>

    <script>

        // import components

        import '../../components/nav-bar/nav-bar.tag.html';
        import '../../components/avr-footer/avr-footer.tag.html';


        // app instance
        const app = this;

    </script>
</app>


// WEBPACK FOOTER //
// avr_eshop/frontend/apps/engineering/app.tag.html